import React from "react";
import { IconOptions } from "./utils/iconOptions";
import { classNames } from "./utils/classNames";
export var Avatar = function (_a) {
    var text = _a.text, loading = _a.loading, img = _a.img, icon = _a.icon, size = _a.size;
    var firstChar = function () {
        if (text)
            return text.charAt(0);
        return undefined;
    };
    if (loading) {
        return React.createElement("div", { className: "avatar avatar--loading" });
    }
    var iconType = icon && IconOptions[icon].type === "pro" ? "glyphicon-pro" : "glyphicon";
    var iconValue = icon && IconOptions[icon].value;
    return (React.createElement("div", { className: classNames("avatar", img ? "avatar--img" : "avatar--static", size ? "avatar--".concat(size) : "") },
        img && (React.createElement("div", { style: {
                backgroundImage: "url(".concat(img, ")"),
            } })),
        !img && React.createElement("span", null, firstChar()),
        icon && (React.createElement("span", { className: "icon ".concat(iconType, " ").concat(iconType, "-").concat(iconValue) }))));
};
